<template>
	<gc-dialog
		title="图片预览"
		width="1180px"
		:show.sync="visible"
		:showFooter="false"
		:append-to-body="true"
		:isPadding="false"
		@cancel="$emit('close-modal')"
		@close="$emit('close-modal')"
	>
		<div class="image-preview-content" v-loading="loading">
			<ul v-if="alarmPhotos.length">
				<li
					v-for="(item, index) in alarmPhotos"
					:key="index"
					:class="{ selected: item.eventTime === selectEventTime }"
					@click="handleChangeEventPhotos(item)"
				>
					<p>{{ item.eventTime }}</p>
				</li>
			</ul>
			<div class="content">
				<el-carousel
					v-if="imageList.length"
					:interval="4000"
					:autoplay="false"
					indicator-position="none"
					type="card"
					height="280px"
				>
					<el-carousel-item v-for="(item, index) in imageList" :key="index">
						<el-image
							style="width: 100%; height: 100%; border-radius: 6px"
							:src="item"
							fit="cover"
						></el-image>
					</el-carousel-item>
				</el-carousel>
				<gc-empty v-else></gc-empty>
			</div>
		</div>
	</gc-dialog>
</template>

<script>
import { apiGetBrsPhotos } from '@/apis/account.api'
export default {
	props: {
		alarmId: Number,
	},
	data() {
		return {
			visible: true,
			loading: true,
			selectEventTime: null,
			alarmPhotos: [],
			imageList: [],
		}
	},
	created() {
		this.queryBrsAlarmPhotoList()
	},

	methods: {
		async queryBrsAlarmPhotoList() {
			this.loading = true
			try {
				const data = await apiGetBrsPhotos({ alarmId: this.alarmId })
				this.alarmPhotos = data
				this.selectEventTime = data[0]?.eventTime
				this.imageList = data[0]?.imageUrlList || []
			} finally {
				this.loading = false
			}
		},

		handleChangeEventPhotos(rowItem) {
			if (rowItem.eventTime === this.selectEventTime) return
			this.selectEventTime = rowItem.eventTime
			this.imageList = rowItem.imageUrlList
		},
	},
}
</script>
<style lang="scss" scoped>
.image-preview-content {
	height: 70vh;
	display: flex;
	border-top: 1px solid #f1f1f1;
	ul {
		width: 200px;
		border-right: 1px solid #f1f1f1;
		padding: 12px 8px;
		li {
			padding: 0 12px;
			line-height: 42px;
			border-radius: 4px;
			cursor: pointer;
			& + li {
				margin-top: 6px;
			}
			&.selected {
				background-color: #e8f2ff;
				color: #2f87fe;
			}
			&:hover {
				background-color: #e8f2ff;
			}
		}
	}
	.content {
		flex: 1;
		width: 0;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 12px;
	}
}
</style>
